import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

export const useRevenueSourcesStore = defineStore('revenue-sources-classes', {
  state: () => ({
    revenueSources: [],
  }),

  actions: {
    loadRevenueSources(params = {}) {
      this.revenueSources = [];

      const query = new URLSearchParams();

      if (params.lang) {
        query.append('lang', params.lang);
      }

      if (params.country?.length) {
        query.append('country', params.country.join(','));
      }

      if (params.city?.length) {
        query.append('city', params.city.join(','));
      }

      if (params.procurement_type?.length) {
        query.append('procurement_type', params.procurement_type.join(','));
      }

      if (params.business_model_typology?.length) {
        query.append('business_model_typology', params.business_model_typology.join(','));
      }

      if (params.city_population_range?.length) {
        query.append('city_population_range', params.city_population_range.join(','));
      }

      return apiFetch({
        path: `/wp-json/ebus/market/revenue-source-classes?${query.toString()}`,
      }).then((data) => {
        this.revenueSources = data;
        
        return data;
      }).catch((error) => {
        console.log('Error: ', error);
      });
    },
  },
});
